import { useQuery } from '@tanstack/react-query'
import { reverseGeocode } from '../api/geocode'
import type { DeliveryLocation } from '../constants/location'
import { QUERY_KEYS } from '../constants/query'
import { deliveryLocationPincode } from '../helpers/location'

/** Resolves the delivery area's pincode, reverse-geocoding older saved areas that lack one. */
export function useLocationPincode(location: DeliveryLocation | null) {
  const known = deliveryLocationPincode(location)
  const lat = typeof location?.lat === 'number' ? location.lat : null
  const lng = typeof location?.lng === 'number' ? location.lng : null
  const query = useQuery({
    queryKey: QUERY_KEYS.locationPincode(lat, lng),
    queryFn: async () => {
      const resolved = await reverseGeocode(lat as number, lng as number)
      return resolved?.pincode ?? ''
    },
    enabled: !known && lat != null && lng != null,
    staleTime: Infinity,
    retry: 1,
  })

  return {
    pincode: known || query.data || '',
    resolving: !known && query.isFetching,
  }
}
